import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { SimplePageLayout } from 'components/layouts/SimplePageLayout';
import { PageLayout } from 'components/PageLayout';
import { ResetPasswordConfirmationContent } from './ResetPasswordConfirmationContent';

export const Content = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('resetPasswordConfirmation.title')}</title>
      </Helmet>
      <SimplePageLayout>
        <ResetPasswordConfirmationContent />
      </SimplePageLayout>
    </>
  );
};

export const ResetPasswordConfirmation = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <PageLayout
      data-cname="ResetPasswordPage"
      headerBarProps={{
        action: '/',
        title: t('resetPasswordConfirmation.title'),
      }}
    >
      <Content />
    </PageLayout>
  );
};
